import React from 'react';

export default React.forwardRef(function TextTooltip({ children, visible, backgroundClass = 'tw-bg-charcoal-50', ...props }, ref) {
    return (
        visible && (
            <div
                ref={ref}
                {...props}
                className={'tw-flex tw-flex-col tw-gap-y-2 tw-p-3 tw-rounded-lg tw-border-0 tw-opacity-90 tw-max-w-md tw-z-[999] ' + backgroundClass}
                role="tooltip"
            >
                {typeof children === 'string' ? (
                    <div className="tw-p-0 tw-text-sm tw-text-white tw-font-medium tw-bg-transparent" dangerouslySetInnerHTML={{ __html: children }}></div>
                ) : (
                    <div className="tw-p-0 tw-text-sm tw-text-white tw-font-medium tw-bg-transparent">{children}</div>
                )}
            </div>
        )
    );
});
